<template>
  <div class="fill-height d-flex flex-column justify-space-around text-center mx-6">
    <div>
      <img src="@/assets/img/context/group.png" />
      <h1>
        {{ $t('EVALUATE.POST.WELCOME.TITLE') }}
      </h1>
      <p class="mt-6">
        {{ $t('EVALUATE.POST.WELCOME.DESCRIPTION_1') }}
      </p>
      <p class="">
        {{ $t('EVALUATE.POST.WELCOME.DESCRIPTION_2') }}
      </p>
      <p class="">
        {{ $t('EVALUATE.POST.WELCOME.DESCRIPTION_3') }}
      </p>
    </div>

    <p>
      <BaseButton @click="$emit('next')">
        {{ $t('EVALUATE.POST.WELCOME.START') }}
      </BaseButton>
    </p>
  </div>
</template>

<script>
export default {
  name: 'FormPostWelcome',
};
</script>
